//Similar to FuseCollapsible Component, but relies on parent to determine whether its toggled
import { Segment, Header, Icon, Grid } from 'semantic-ui-react';

export default function FuseControlledCollapsiblePanel({
  content,
  header,
  leadingIcon,
  trailingIcon,
  isCollapsed,
  onToggle,
  differentiate
}) {
  return (
    <div>
      <Header
        attached="top"
        inverted
        className={`clickable ${
          differentiate ? 'nectaPrimaryBg' : 'nectaDarkGreyBg'
        }`}
        onClick={onToggle}    // just call the parent’s toggle
      >
        <Grid>
          {leadingIcon && (
            <Grid.Column width={1} verticalAlign="middle" className="nectaPrimaryBg">
              <Icon name={leadingIcon} />
            </Grid.Column>
          )}
          <Grid.Column width={leadingIcon ? 14 : 15} verticalAlign="middle">
            {header}
          </Grid.Column>
          {trailingIcon && (
            <Grid.Column width={1} verticalAlign="middle">
              <Icon name={isCollapsed ? 'angle down' : 'angle up'} />
            </Grid.Column>
          )}
        </Grid>
      </Header>

      <Segment attached className={isCollapsed ? 'isCollapsed' : ''}>
        {content}
      </Segment>
    </div>
  );
}

FuseControlledCollapsiblePanel.defaultProps = {
  content: null,
  isCollapsed: true,
  leadingIcon: '',
  trailingIcon: '',
  differentiate: false,
};
